import React, { useEffect, useState, Suspense, lazy, createElement } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
const PainPoints = lazy(() => import('./components/PainPoints').then(m => ({
  default: m.PainPoints
})));
const SolutionSection = lazy(() => import('./components/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const ForWhomSection = lazy(() => import('./components/ForWhomSection').then(m => ({
  default: m.ForWhomSection
})));
const WhatIncludes = lazy(() => import('./components/WhatIncludes').then(m => ({
  default: m.WhatIncludes
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const PricingBlock = lazy(() => import('./components/PricingBlock').then(m => ({
  default: m.PricingBlock
})));
const VisualSummary = lazy(() => import('./components/VisualSummary').then(m => ({
  default: m.VisualSummary
})));
const HowItWorks = lazy(() => import('./components/HowItWorks').then(m => ({
  default: m.HowItWorks
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const Testimonials = lazy(() => import('./components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
import { Footer } from './components/Footer';
import { FloatingTestimonials } from './components/FloatingTestimonials';
import { SocialProofNotification } from './components/SocialProofNotification';
export function App() {
  const [showDelayed, setShowDelayed] = useState(false);
  useEffect(() => {
    // Preload hero image for LCP
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = 'https://cdn.magicpatterns.com/uploads/weZNi8v327p5FmXUx2Mo7F/metodo_flash_1280_q75.webp';
    link.imageSrcset = 'https://cdn.magicpatterns.com/uploads/weZNi8v327p5FmXUx2Mo7F/metodo_flash_1280_q75.webp 1280w, https://cdn.magicpatterns.com/uploads/weZNi8v327p5FmXUx2Mo7F/metodo_flash_1280_q75.webp 768w';
    link.imageSizes = '(max-width: 768px) 768px, 1280px';
    link.fetchPriority = 'high';
    document.head.appendChild(link);
    // Delay non-critical components and scripts to prioritize LCP
    const timer = setTimeout(() => {
      initMetaPixel('1313291250496067');
      setShowDelayed(true);
    }, 3500); // 3.5s delay
    return () => clearTimeout(timer);
  }, []);
  return <div className="min-h-screen font-sans text-white selection:bg-brand-badge selection:text-white pb-0" data-id="element-0">
      {showDelayed && <UrgencyBar data-id="element-1" />}
      {showDelayed && <FloatingTestimonials data-id="element-2" />}
      {showDelayed && <SocialProofNotification data-id="element-3" />}

      <main data-id="element-4">
        <HeroSection data-id="element-5" />
        <Suspense fallback={<div className="h-20" data-id="element-7" />} data-id="element-6">
          <PainPoints data-id="element-8" />
          <SolutionSection data-id="element-9" />
          <ForWhomSection data-id="element-10" />
          <WhatIncludes data-id="element-11" />
          <BonusSection data-id="element-12" />
          <PricingBlock data-id="element-13" />
          <VisualSummary data-id="element-14" />
          <HowItWorks data-id="element-15" />
          <GuaranteeSection data-id="element-16" />
          <Testimonials data-id="element-17" />
          <FAQSection data-id="element-18" />
          <FinalCTA data-id="element-19" />
        </Suspense>
      </main>

      <Footer data-id="element-20" />
    </div>;
}